exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.imgbox[data-v-52778f40] {\n  width: 100%;\n  height: 18.75rem;\n}\n#play[data-v-52778f40] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  z-index: 1;\n}", ""]);

// exports
